export var ApplicationChannel;
(function (ApplicationChannel) {
    ApplicationChannel["ONLINE"] = "ONLINE";
    ApplicationChannel["OFFLINE"] = "OFFLINE";
    ApplicationChannel["BOTH"] = "BOTH";
})(ApplicationChannel || (ApplicationChannel = {}));
